export default class NewJourney {
    constructor (
        hardwareId
    ) {
        this.hardwareId = hardwareId
    }
}
